import React from 'react';

const StaffDetails = ({ formData }) => {
  return (
    <div className="form-section">
      <div className="section-content">

        {/* Mentor Details */}
        <div className="form-row">
          <div className="form-group">
            <label className="label">Mentor Name</label>
            <input
              type="text"
              value={formData.mentor || ''}
              readOnly
              className="input"
              style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
            />
          </div>

          <div className="form-group">
            <label className="label">Mentor Number</label>
            <input
              type="text"
              value={formData.mentorNumber || ''}
              readOnly
              className="input"
              style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
            />
          </div>
        </div>

        {/* Staff Details */}
        <div className="form-row">
          <div className="form-group">
            <label className="label">Staff Name 1</label>
            <input
              type="text"
              value={formData.staffName1 || ''}
              readOnly
              className="input"
              style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
            />
          </div>

          <div className="form-group">
            <label className="label">Staff Name 2</label>
            <input
              type="text"
              value={formData.staffName2 || ''}
              readOnly
              className="input"
              style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
            />
          </div>

          <div className="form-group">
            <label className="label">Staff Name 3</label>
            <input
              type="text"
              value={formData.staffName3 || ''}
              readOnly
              className="input"
              style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
            />
          </div>
        </div>

      </div>
    </div>
  );
};

export default StaffDetails;
